import {useFormContext} from "react-hook-form";
import dohvatiVrijednostPolja from "./dohvatiVrijednostPolja";

const useDaLiJePoljeValidno = (nazivPolja: string) => {
    const { formState: { errors } } = useFormContext();
    return !dohvatiVrijednostPolja(errors, nazivPolja);
}

export default useDaLiJePoljeValidno;